var star3 = "/static/4bd8ef7c6d4325a2.webp";

export { star3 as default };
//# sourceMappingURL=star-3.webp.js.map
